export default __webpack_public_path__ + "static/media/remove.ee5d5e3a.svg";